/* ==========================================================================
   Botaverra - apparition au scroll, toutes les pages, de la premiere section
   jusqu'au pied de page inclus.

   Se greffe sur botaverra-futuristic.js sans le modifier (celui-ci est minifie
   en ligne et contient le bloc des bulles Twin Tower). Les deux sont `defer`,
   donc executes dans l'ordre du document : ses `.bv-reveal` sont deja poses.
   ========================================================================== */

(function () {
  var body = document.body;
  if (!body) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var DUREE = 900;
  var PAS = 90;
  var RANG_MAX = 5;
  var MARGE = 120;

  /* Ecarte les conteneurs enormes du flou : rasteriser une texture de
     plusieurs milliers de pixels figeait l'onglet. */
  var SEUIL_FLOU = 2.5;

  /* Au-dela de 25% de l'ecran, on anime les blocs internes plutot que le bloc
     entier. Deux raisons : une cible qui couvre toute une section se declenche
     bien avant que le visiteur ne la voie (l'animation est finie quand il
     arrive dessus), et une grande surface floutee fait ramer le defilement. */
  var SEUIL_DECOUPE = 0.25;

  /* Au-dela de ce nombre de blocs issus d'un meme conteneur, la cascade devient
     illisible. On garde alors les enfants de ce niveau - surtout PAS le parent,
     qui serait justement la cible geante qu'on cherche a eviter. */
  var MAX_BLOCS = 8;

  function fenetrePrete() {
    return window.innerHeight > 0 && window.innerWidth > 0;
  }

  function sectionsUtiles() {
    var racine = document.querySelector('.page-wrapper') || document;
    return [].slice.call(racine.querySelectorAll('.shopify-section')).filter(function (s) {
      return !s.closest('#header-group');
    });
  }

  /* Les sections s'ouvrent souvent par un <style> inline : display:none, donc
     jamais vu par l'IntersectionObserver. On teste display et non la taille,
     car ce script tourne avant `load` et les conteneurs d'images mesurent 0. */
  function estRendu(el) {
    if (!el || el.nodeType !== 1) return false;
    var t = el.tagName;
    if (t === 'STYLE' || t === 'SCRIPT' || t === 'LINK' || t === 'TEMPLATE' || t === 'NOSCRIPT') {
      return false;
    }
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  /* Horizon place un calque de fond en premier enfant de section :
     <div class="section-background"> vide, de la taille de la section. Le
     prendre pour cible revient a animer le fond et pas le contenu. */
  function estDecoratif(el) {
    if (el.classList.contains('section-background')) return true;
    return el.children.length === 0 && !(el.textContent || '').trim();
  }

  function utilisables(liste) {
    return liste.filter(function (el) {
      return estRendu(el) && !estDecoratif(el);
    });
  }

  function ciblesDe(section) {
    if (section.querySelectorAll('.bv-reveal').length) return [];

    var wrap = section.querySelector('.section-content-wrapper');
    if (wrap) {
      var a = utilisables([].slice.call(wrap.children));
      if (a.length) return a;
    }

    var inner = section.querySelector('.bvs__inner, .page-width, .section-content');
    if (inner) {
      var b = utilisables([].slice.call(inner.children));
      if (b.length > 1) return b;
    }

    var c = utilisables([].slice.call(section.children));
    return c.length ? [c[0]] : [];
  }

  /* profondeur ne compte que les ramifications : traverser une chaine de
     conteneurs a enfant unique ne multiplie pas les cibles. */
  function decouper(el, seuil, profondeur, descentes) {
    if (el.getBoundingClientRect().height <= seuil) return [el];
    if (profondeur >= 3 || descentes >= 12) return [el];

    var enfants = utilisables([].slice.call(el.children));
    if (!enfants.length) return [el];
    if (enfants.length === 1) return decouper(enfants[0], seuil, profondeur, descentes + 1);

    var out = [];
    enfants.forEach(function (enfant) {
      out = out.concat(decouper(enfant, seuil, profondeur + 1, descentes + 1));
    });
    return out.length > MAX_BLOCS ? enfants : out;
  }

  /* Un transform sur un ancetre d'elements absolus les fait sauter pendant
     l'animation (etiquettes de la tour). Inspection plafonnee. */
  function contientAbsolu(el) {
    var noeuds = el.querySelectorAll('*');
    var max = Math.min(noeuds.length, 60);
    for (var i = 0; i < max; i++) {
      var p = getComputedStyle(noeuds[i]).position;
      if (p === 'absolute' || p === 'fixed') return true;
    }
    return false;
  }

  function marquer(el, seuilFlou) {
    if (el.getBoundingClientRect().height > seuilFlou) el.classList.add('bv-reveal--sobre');
    if (contientAbsolu(el)) el.classList.add('bv-reveal--fixe');
    el.classList.add('bv-reveal');
  }

  /* FILET DE SECURITE - une cible sans boite (largeur ou hauteur nulle) ne
     franchira jamais le seuil de l'IntersectionObserver : elle resterait a
     opacity 0 pour toujours et son contenu disparaitrait purement et
     simplement. C'est le cas des etiquettes en position absolue du schema de
     la tour ("Bac nutritif", "Colonne montante"...). On les revele d'office :
     elles n'ont de toute facon rien a animer. */
  function revelerLesSansBoite() {
    [].slice.call(document.querySelectorAll('.bv-reveal')).forEach(function (el) {
      if (el.classList.contains('bv-reveal--visible')) return;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) {
        el.classList.add('bv-reveal--visible', 'bv-reveal--done');
      }
    });
  }

  function poserCibles() {
    var seuilFlou = fenetrePrete() ? window.innerHeight * SEUIL_FLOU : Infinity;
    var seuilDecoupe = fenetrePrete() ? window.innerHeight * SEUIL_DECOUPE : Infinity;

    sectionsUtiles().forEach(function (section) {
      ciblesDe(section).forEach(function (el) {
        decouper(el, seuilDecoupe, 0, 0).forEach(function (cible) {
          marquer(cible, seuilFlou);
        });
      });
    });
  }

  /* Les images n'ont pas leur taille avant `load` : une section qui mesurait
     300px peut en faire 1100 ensuite, et son unique cible couvre alors toute
     la section. On redecoupe celles qui n'ont pas encore ete revelees. */
  function affiner() {
    if (!fenetrePrete()) return;
    var seuilFlou = window.innerHeight * SEUIL_FLOU;
    var seuilDecoupe = window.innerHeight * SEUIL_DECOUPE;

    [].slice.call(document.querySelectorAll('.bv-reveal')).forEach(function (el) {
      if (el.classList.contains('bv-reveal--visible')) return;
      if (el.getBoundingClientRect().height <= seuilDecoupe) return;

      var sous = decouper(el, seuilDecoupe, 0, 0);
      if (sous.length < 2) return;

      el.classList.remove('bv-reveal', 'bv-reveal--sobre', 'bv-reveal--fixe');
      el.style.removeProperty('--bv-delay');
      sous.forEach(function (cible) {
        marquer(cible, seuilFlou);
      });
    });

    classerLeFlou();
    poserDelais();
    observerTous();
    revelerLesSansBoite();
  }

  function classerLeFlou() {
    if (!fenetrePrete()) return;
    var seuil = window.innerHeight * SEUIL_FLOU;
    [].slice.call(document.querySelectorAll('.bv-reveal')).forEach(function (el) {
      el.classList.toggle('bv-reveal--sobre', el.getBoundingClientRect().height > seuil);
    });
  }

  /* Rang compte par section : un compteur global donnerait au bas de page un
     delai de plusieurs secondes. */
  function poserDelais() {
    sectionsUtiles().forEach(function (section) {
      var rang = 0;
      [].slice.call(section.querySelectorAll('.bv-reveal')).forEach(function (el) {
        el.style.setProperty('--bv-delay', Math.min(rang, RANG_MAX) * PAS + 'ms');
        rang++;
      });
    });
  }

  var io = null;

  function observerTous() {
    var els = [].slice.call(document.querySelectorAll('.bv-reveal')).filter(function (el) {
      return !el.hasAttribute('data-bv-vu');
    });
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('bv-reveal--visible', 'bv-reveal--done');
      });
      return;
    }

    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            io.unobserve(el);
            el.classList.add('bv-reveal--visible');
            var delai = parseFloat(el.style.getPropertyValue('--bv-delay')) || 0;
            setTimeout(function () {
              el.classList.add('bv-reveal--done');
            }, DUREE + delai + MARGE);
          });
        },
        /* Declenchement independant de la taille : un seuil en pourcentage
           revelerait un bloc de 1000px des que 120px sont visibles, donc bien
           avant que le visiteur n'y arrive. Ici tout element se revele quand
           son haut franchit 82% de la hauteur d'ecran. */
        { threshold: 0, rootMargin: '0px 0px -18% 0px' }
      );
    }

    els.forEach(function (el) {
      el.setAttribute('data-bv-vu', '');
      io.observe(el);
    });
  }

  /* Classes du defilement par section, retire le 2026-08-15 : une page en
     cache pourrait encore les porter, et .bv-snap--plein imposait
     min-height:100vh, ce qui separait les sections. */
  function retirerAncienSnap() {
    [].slice.call(document.querySelectorAll('.bv-snap, .bv-snap--plein')).forEach(function (el) {
      el.classList.remove('bv-snap', 'bv-snap--plein');
    });
  }

  var minuterie;
  function plusTard() {
    clearTimeout(minuterie);
    minuterie = setTimeout(affiner, 200);
  }

  retirerAncienSnap();
  poserCibles();
  poserDelais();
  observerTous();

  window.addEventListener('load', affiner);
  window.addEventListener('resize', plusTard);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) plusTard();
  });
})();
